module.exports = __webpack_public_path__ + "static/img/company-component-coveEn-4.3a0eccab.jpg";